
import Vue from 'vue'
import {GET_MODE, IS_INVALID_TOKEN, IS_USER_LOGGED_IN} from '@/store/getter-types'
import {AUTH_LOG_USER_IN, SET_INVALID_TOKEN} from '@/store/action-types'
import {UserCredentialsPayload} from '@/types/payload'
import InvalidCredentialsError from '@/model/error/InvalidCredentialsError'
import {getSetting} from '@/services/settings'
import {Component, Watch} from 'vue-property-decorator'
import {TranslateResult} from "vue-i18n";
import {Action, Getter} from "vuex-class";
import LoginPageKiosk from "@/pages/LoginPageKiosk.vue";
import moment from "moment/moment";
import i18n from "@/plugins/i18n";
import LanguageSelectionButton from "@/components/user/LanguageSelectionButton.vue";

@Component({
  components: {
    LoginPageKiosk,
    LanguageSelectionButton
  }
})
export default class LoginPage extends Vue {
  $refs!: {
    loginForm: Vue & { validate(): boolean }
  }

  private username: string | null = null
  private password: string | null = null
  private showPassword: boolean = false

  private usernameValidationRules: Function[] = [
    (v: string): boolean | string => !!v || i18n.t('validation.valueIsRequired').toString()
  ]

  private passwordValidationRules: Function[] = [
    (v: string): boolean | string => !!v || i18n.t('validation.valueIsRequired').toString()
  ]

  private formIsValid: boolean = false
  private showErrorSnackbar: boolean = false
  private errorMessage: TranslateResult | null = null
  private fetchInProgress: boolean = false

  @Action(AUTH_LOG_USER_IN) performLogin!: { (payload: UserCredentialsPayload): Promise<void> }
  @Getter(IS_INVALID_TOKEN) isInvalidToken!: boolean
  @Action(SET_INVALID_TOKEN) setInvalidToken!: { (payload: boolean): void }

  get isKioskMode (): boolean {
    return this.$store.getters[GET_MODE] === 'kiosk'
  }

  get isUserLoggedIn(): boolean {
    return this.$store.getters[IS_USER_LOGGED_IN]
  }

  get passwordFieldType(): string {
    return this.showPassword ? 'text' : 'password'
  }

  get passwordFieldIcon(): string {
    return this.showPassword ? 'fa-eye-slash' : 'fa-eye'
  }

  @Watch('isUserLoggedIn')
  onIsUserLoggedInChange(newVal: boolean): void {
    const changePin = getSetting('boarder.force_pin_change')
    if (changePin && changePin.value === 'true' && !this.isKioskMode) {
      this.$router.push({name: 'ChangePin'})
    } else {
      if (newVal && !this.isKioskMode) {
        this.$router.push({name: 'Dashboard'})
      } else if(newVal && this.isKioskMode) {
        this.$router.push({
          name: 'Order',
          params: {
            isoWeek: moment().format('GGGG[W]WW'),
            date: moment().format('YYYY-MM-DD')
          }
        })
      }
    }
  }

  onToggleShowPasswordClick(): void {
    this.showPassword = !this.showPassword
  }

  onFormSubmit(): void {
    if (this.$refs.loginForm.validate()) {
      const payload: UserCredentialsPayload = {
        username: this.username!,
        password: this.password!
      }
      this.fetchInProgress = true
      this.setInvalidToken(false)

      this.$store.dispatch(AUTH_LOG_USER_IN, payload)
        .catch((e: InvalidCredentialsError) => {
          this.errorMessage = e.message
          this.showErrorSnackbar = true
          this.fetchInProgress = false
        })

      //this.$store.commit(SET_CURRENT_DAILYMENU_TOP_GROUP_OFFER, undefined)
    }
  }

  onPasswordRecoveryButtonClick(): void {
    this.$router.push({name: 'PasswordRecovery'})
  }

  mounted(): void {
    this.errorMessage = this.$t('loginPage.loginFail')
  }
}
